import React from 'react'
import './Status.css'
import {Button} from '../../Button/Button'
import getCardSize from '../../../helpers/getCardSize'
import {Rules} from './Rules'

type StatusProps = {
    gameStarted: boolean
    countBattleCards: number
    onClickStart: Function
    turn?: string
    lang: string
}

type StatusState = {
    top: number
}

export class Status extends React.Component<StatusProps, StatusState> {
    constructor(props: StatusProps) {
        super(props)

        this.state = {
            top: Status.getTop(),
        }
    }

    render(): JSX.Element {
        const {turn, countBattleCards, gameStarted} = this.props

        if (gameStarted) {
            const {top} = this.state

            return (
                <div className="Status Status_game" style={{top: top + 'px'}}>
                    {turn && countBattleCards === 0 && this.status()}
                </div>
            )
        }
        return (
            <div className="Status Status_intro" data-scrollable="true">
                <div className="Status-gameRules" style={{paddingTop: getCardSize().height + 10 + 'px'}}>
                    <Rules lang={this.props.lang} />
                    <div className="Status-button-w">
                        <Button size="XL" onClick={() => this.onClick()}>
                            {this.props.lang === 'ru' ? 'Играть!' : 'Start Game!'}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    componentDidMount(): void {
        window.addEventListener('resize', this.onResize)
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize)
    }

    private status(): string {
        const user = this.props.turn === 'user'

        if (this.props.lang === 'ru') {
            return user ? 'Ваш ход...' : 'Ходит Балда'
        } else {
            return user ? 'Your turn...' : 'The opponent’s move...'
        }
    }

    private static getTop(): number {
        return Math.round(window.innerHeight / 2)
    }

    private onClick(): void {
        if (this.props.onClickStart) {
            this.props.onClickStart()
        }
    }

    private onResize = () => {
        this.setState({
            top: Status.getTop(),
        })
    }
}
